import React, { useState } from "react";
import styled from "styled-components";

export default function Input({
  name,
  label,
  onChange,
  placeholder,
  value,
  background,
}) {
  const [type, setType] = useState("password");
  const [readOnly, setReadOnly] = useState(false);

  return (
    <AppInputStyle style={{ background: background ? background : "white" }}>
      <div>
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          autocomplete="off"
          readOnly={readOnly}
          onFocus={() => setReadOnly(false)}
          onBlur={() => setReadOnly(true)}
          defaultValue={value}
        />
        <svg
          onClick={() => {
            setType(type === "password" ? "text" : "password");
          }}
          className="eye"
          width="20"
          height="17"
          viewBox="0 0 20 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.84546 5.36842L12.7273 8.19579V8.05263C12.7273 7.34073 12.4399 6.65799 11.9285 6.15461C11.417 5.65122 10.7233 5.36842 10 5.36842H9.84546ZM5.93636 6.08421L7.34545 7.47105C7.3 7.65895 7.27273 7.84684 7.27273 8.05263C7.27273 8.76453 7.56006 9.44727 8.07153 9.95065C8.58299 10.454 9.27668 10.7368 10 10.7368C10.2 10.7368 10.4 10.71 10.5909 10.6653L12 12.0521C11.3909 12.3474 10.7182 12.5263 10 12.5263C8.79447 12.5263 7.63832 12.055 6.78588 11.216C5.93344 10.377 5.45455 9.23913 5.45455 8.05263C5.45455 7.34579 5.63636 6.68368 5.93636 6.08421ZM0.909091 1.13632L2.98182 3.17632L3.39091 3.57895C1.89091 4.74211 0.709091 6.26316 0 8.05263C1.57273 11.9805 5.45455 14.7632 10 14.7632C11.4091 14.7632 12.7545 14.4947 13.9818 14.0116L14.3727 14.3874L17.0273 17L18.1818 15.8637L2.06364 0M10 3.57895C11.2055 3.57895 12.3617 4.05028 13.2141 4.88926C14.0666 5.72824 14.5455 6.86614 14.5455 8.05263C14.5455 8.62526 14.4273 9.18 14.2182 9.68105L16.8818 12.3026C18.2455 11.1842 19.3364 9.71684 20 8.05263C18.4273 4.12474 14.5455 1.34211 10 1.34211C8.72727 1.34211 7.50909 1.56579 6.36364 1.96842L8.33636 3.89211C8.85455 3.69526 9.40909 3.57895 10 3.57895Z"
            fill="#BDBDBD"
            fill-opacity="0.8"
          />
        </svg>
      </div>
    </AppInputStyle>
  );
}

const AppInputStyle = styled.div`
  width: 100%;
  outline: none;
  border-radius: 8px;
  background-color: white;
  padding: 0;
  position: relative;
  margin-bottom: 20px;

  input {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 6px;
    outline: none;
    border: none;
    background: none;
    padding: 25px 20px;
    font-size: 16px;
  }
  input::placeholder {
    color: #516b91;
  }

  .eye {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }
`;
